import {
  Autocomplete,
  Box,
  CircularProgress,
  Divider,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { useModelList } from "../../hooks/useModelList.js";
import { t } from "i18next";
import { useEffect, useState } from "react";

export default function SelectTrainType({
  formData,
  updateFormData,
  selectedTrainModel,
  selectedInspModel,
  setSelectedTrainModel,
  setSelectedInspModel,
  selectTrainType,
  setSelectTrainType,
}) {
  const [trainInputValue, setTrainInputValue] = useState("");
  const [inspInputValue, setInspInputValue] = useState("");

  const {
    modelList: trainModelList,
    isLoading: isTrainLoading,
    loadMore: loadMoreTrainModels,
    page: trainPage,
  } = useModelList("train");

  const {
    modelList: inspModelList,
    isLoading: isInspLoading,
    loadMore: loadMoreInspModels,
    page: inspPage,
  } = useModelList("insp");

  const handleSelectTrainModel = (model) => {
    setSelectedTrainModel(model);
    if (model) {
      updateFormData("trainModel_id", model.id);
      updateFormData("options", model.options || "{}");
      updateFormData("pre_process", model.pre_process || "{}");
      updateFormData("post_process", model.post_process || "{}");
      updateFormData("type", model.type || "");
    }
  };

  const handleSelectInspModel = (model) => {
    // console.log("model", model);
    setSelectedInspModel(model);
    if (model) {
      updateFormData("inspModel_id", model.id);
      updateFormData("options", model.options || "{}");
      updateFormData("pre_process", model.pre_process || "{}");
      updateFormData("post_process", model.post_process || "{}");
      updateFormData("inspModel_uuid", model.uuid || null);
    }
  };

  const handleTrainScroll = (event) => {
    const listbox = event.target;
    if (
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 20 &&
      !isTrainLoading
    ) {
      loadMoreTrainModels(trainPage + 1);
    }
  };

  const handleInspScroll = (event) => {
    const listbox = event.target;
    if (
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 20 &&
      !isInspLoading
    ) {
      loadMoreInspModels(inspPage + 1);
    }
  };

  const handleTabCodeChange = (model) => {
    // console.log("model", model);
    if (!model) return;

    const fieldsToUpdate = ["options", "pre_process", "post_process"];

    fieldsToUpdate.forEach((field) => {
      if (model[field]) {
        updateFormData(field, model[field]);
      }
    });
  };

  const handleSelectTrainType = (value) => {
    setSelectTrainType(value);
    if (value === "continue") {
      //   setSelectedInspModel(inspModelList[0]);
      // console.log("inspModelList[0]", inspModelList[0]);
      if (!selectedInspModel) {
        setSelectedInspModel(inspModelList[0]);
      }
      handleTabCodeChange(inspModelList[0]);
    } else {
      //   setSelectedTrainModel(trainModelList[0]);
      // console.log("trainModelList[0]", trainModelList[0]);
      handleTabCodeChange(trainModelList[0]);
    }
  };

  return (
    <>
      <Box>
        <Divider>{t("TrainType")}</Divider>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Radio
            checked={selectTrainType === "new"}
            onChange={(e) => handleSelectTrainType(e.target.value)}
            value="new"
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 21,
              },
            }}
          />
          <Typography>{t("NewTrain")}</Typography>
        </div>
        {selectTrainType === "new" && (
          <Autocomplete
            value={selectedTrainModel}
            onChange={(event, newValue) => handleSelectTrainModel(newValue)}
            inputValue={trainInputValue}
            onInputChange={(event, newInputValue) => {
              setTrainInputValue(newInputValue);
            }}
            options={trainModelList}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("TrainModel")}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isTrainLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            ListboxProps={{
              onScroll: handleTrainScroll,
              style: { maxHeight: 200 },
            }}
            loading={isTrainLoading}
            loadingText={t("Loading")}
            noOptionsText={t("NoTrainModels")}
          />
        )}
      </Box>
      <Box>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Radio
            checked={selectTrainType === "continue"}
            onChange={(e) => {
              handleSelectTrainType(e.target.value);
            }}
            value="continue"
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 21,
              },
            }}
          />
          <Typography>{t("ContinueTrain")}</Typography>
        </div>
        {selectTrainType === "continue" && (
          <Autocomplete
            value={selectedInspModel}
            onChange={(event, newValue) => handleSelectInspModel(newValue)}
            inputValue={inspInputValue}
            onInputChange={(event, newInputValue) => {
              setInspInputValue(newInputValue);
            }}
            options={inspModelList}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("InspectionModel")}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isInspLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            ListboxProps={{
              onScroll: handleInspScroll,
              style: { maxHeight: 200 },
            }}
            loading={isInspLoading}
            loadingText={t("Loading")}
            noOptionsText={t("NoInspectionModels")}
          />
        )}
      </Box>
    </>
  );
}
